import { Environment } from '@common/models/Enums';
import { observer } from 'mobx-react';
import React from 'react';

export interface IProps {}

export const EnvironmentBanner = observer(() => {
  const env = appEnv.ENV as Environment;
  const show = env === Environment.dev || env === Environment.training;
  return (
    <>
      {show && (
        <div className="bannerContainer text-center">
          <b className="bannerText">
            DEVELOPMENT-TRAINING SITE ONLY, DO NOT ENTER LIVE DATA
          </b>
        </div>
      )}
    </>
  );
});
